import { GymTypes } from 'fitbeat.models';
import { WorkoutSettings } from '../user';
import { InternalWorkoutReview, InternalWorkoutReviewStatus } from '../workoutsession';
import { WorkoutSelection, WorkoutSelectionStatus } from './workoutselection';

export class WorkoutSelectionWithDisplayInfo {
    public static mapFromWorkoutSelection(workoutSelection: WorkoutSelection): WorkoutSelectionWithDisplayInfo {
        const workoutSelectionWithDisplayInfo = new WorkoutSelectionWithDisplayInfo();

        workoutSelectionWithDisplayInfo.uniqueReference = workoutSelection.uniqueReference;
        workoutSelectionWithDisplayInfo.workoutSequenceDate = workoutSelection.workoutSequenceDate;
        workoutSelectionWithDisplayInfo.settings = workoutSelection.settings;
        workoutSelectionWithDisplayInfo.internalWorkoutReview = workoutSelection.internalWorkoutReview;
        workoutSelectionWithDisplayInfo.powerInternalWorkoutReview = workoutSelection.powerInternalWorkoutReview;
        workoutSelectionWithDisplayInfo.gymType = workoutSelection.gymType;
        workoutSelectionWithDisplayInfo.areAllExercisesAndZonesNotFaulty =
            WorkoutSelection.areAllExercisesOrZonesNotFaulty(workoutSelection);
        workoutSelectionWithDisplayInfo.areAllExercisesApproved =
            WorkoutSelection.areAllExercisesApproved(workoutSelection);

        return workoutSelectionWithDisplayInfo;
    }

    public static getWorkoutState(workout: WorkoutSelectionWithDisplayInfo): WorkoutSelectionStatus {
        if (!workout.areAllExercisesApproved) {
            return WorkoutSelectionStatus.WorkoutIncomplete;
        } else if (workout.internalWorkoutReview &&
            workout.internalWorkoutReview.disagreeComment !== undefined) {
            return WorkoutSelectionStatus.DisagreeWithFail;
        } else if (workout.internalWorkoutReview &&
            workout.internalWorkoutReview.reviewStatus === InternalWorkoutReviewStatus.Fail) {
            return WorkoutSelectionStatus.ReviewFailed;
        } else if (!workout.areAllExercisesAndZonesNotFaulty) {
            return WorkoutSelectionStatus.ExerciseFaulty;
        } else if (workout.internalWorkoutReview.reviewStatus === InternalWorkoutReviewStatus.NeedReview) {
            return WorkoutSelectionStatus.AwatingReview;
        }  else  if (workout.internalWorkoutReview &&
            workout.internalWorkoutReview.reviewStatus === InternalWorkoutReviewStatus.Pass) {
            return WorkoutSelectionStatus.ReviewPassed;
        }

        return WorkoutSelectionStatus.Complete;
    }

    public uniqueReference: string;
    public workoutSequenceDate: number;
    public settings: WorkoutSettings;
    public internalWorkoutReview: InternalWorkoutReview;
    public powerInternalWorkoutReview: InternalWorkoutReview;
    public areAllExercisesAndZonesNotFaulty: boolean;
    public areAllExercisesApproved: boolean;
    public active: boolean;
    public gymType: GymTypes;
}
